var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "otherinformation"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.expanded == false) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Expand All"
    },
    on: {
      "click": _vm.expandAll
    }
  }, [_vm._v("\n          Expand All "), _c('i', {
    staticClass: "fa fa-plus-circle"
  })]) : _vm._e(), _vm._v(" "), (_vm.expanded == true) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Collapse All"
    },
    on: {
      "click": _vm.collapseAll
    }
  }, [_vm._v("\n          Collapse All "), _c('i', {
    staticClass: "fa fa-minus-circle"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "limitTablJolly"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[1]),
      expression: "accordianTab[1]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "ClientKYC",
      "id": "chck1"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[1]) ? _vm._i(_vm.accordianTab[1], null) > -1 : (_vm.accordianTab[1])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(1)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[1] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[1] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 1, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck1"
    }
  }, [_vm._v("General Information")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('form', {
    attrs: {
      "id": "test",
      "data-vv-scope": "generalinformationform"
    }
  }, [_c('div', {
    staticClass: "limitTablJolly"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Company Business/Trade Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" * ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyname),
      expression: "companyname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "tabindex": "1",
      "type": "text",
      "id": "CompanyName",
      "name": "CompanyName",
      "placeholder": "Enter Company Name",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "value": (_vm.companyname)
    },
    on: {
      "keypress": function($event) {
        _vm.AvoidSpaceGeneralInfo($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('generalinformationform.CompanyName')),
      expression: "errors.has('generalinformationform.CompanyName')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Company Business/Trade Name field is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Client Website/Domain Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" * ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companywebsite),
      expression: "companywebsite"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /((http[s])?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,3})/
      }),
      expression: "{required: true,  regex:/((http[s])?:\\/\\/(?:www\\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\\.[^\\s]{2,3})/}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "tabindex": "2",
      "type": "text",
      "id": "CompanyWebsite",
      "name": "CompanyWebsite",
      "placeholder": "Enter Company Website/Domain Name",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "value": (_vm.companywebsite)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companywebsite = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('generalinformationform.CompanyWebsite')),
      expression: "errors.has('generalinformationform.CompanyWebsite')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter valid format of Website/Domain Name")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v(" Business Address")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Address Line 1")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address1),
      expression: "address1"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "id": "Address1",
      "name": "Address1",
      "placeholder": "Address Line 1",
      "tabindex": "2",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "value": (_vm.address1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('generalinformationform.Address1')),
      expression: "errors.has('generalinformationform.Address1')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Address Line 1 field is required")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Address Line 2")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address2),
      expression: "address2"
    }],
    staticClass: "form-control",
    attrs: {
      "tabindex": "3",
      "placeholder": "Address Line 2",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "value": (_vm.address2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address2 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row marginattop"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("State")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    class: {
      changeColor: _vm.disableAllFileds == true
    },
    attrs: {
      "left": "<i class='fa fa-map-pin'></i>"
    }
  }, [_c('treeselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "tabindex": "4",
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.statelist,
      "name": "State",
      "id": "State",
      "placeholder": "Select State",
      "append-to-body": true,
      "disabled": _vm.disableAllFileds
    },
    on: {
      "select": _vm.selectState
    },
    model: {
      value: (_vm.state),
      callback: function($$v) {
        _vm.state = $$v
      },
      expression: "state"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('generalinformationform.State')),
      expression: "errors.has('generalinformationform.State')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The State field is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("City")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    class: {
      changeColor: _vm.disableAllFileds == true
    },
    attrs: {
      "left": "<i class=\"fa fa-map-pin\"></i>"
    }
  }, [_c('treeselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.citylist,
      "name": "City",
      "id": "City",
      "placeholder": "Select City",
      "append-to-body": true,
      "tabindex": "5",
      "disabled": _vm.disableAllFileds
    },
    on: {
      "select": _vm.selectCity
    },
    model: {
      value: (_vm.city),
      callback: function($$v) {
        _vm.city = $$v
      },
      expression: "city"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('generalinformationform.City')),
      expression: "errors.has('generalinformationform.City')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The City field is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Pincode")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class=\"fa fa-map-pin\"></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pincode),
      expression: "pincode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "tabindex": "6",
      "type": "text",
      "placeholder": "Enter Pincode",
      "name": "Pincode",
      "id": "Pincode",
      "maxlength": 6,
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "value": (_vm.pincode)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.handleTab(1)
      },
      "keypress": function($event) {
        _vm.isIntegerOnlty($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pincode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('generalinformationform.Pincode')),
      expression: "errors.has('generalinformationform.Pincode')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('generalinformationform.Pincode')))])], 1)])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[2]),
      expression: "accordianTab[2]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "ClientKYC",
      "id": "chck2"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[2]) ? _vm._i(_vm.accordianTab[2], null) > -1 : (_vm.accordianTab[2])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(2)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[2],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[2] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[2] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 2, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck2"
    }
  }, [_vm._v("Client SPOC Details")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('form', {
    attrs: {
      "id": "test",
      "data-vv-scope": "spocdetailsform"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("First Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-male'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fname),
      expression: "fname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "tabindex": "7",
      "id": "FirstName",
      "name": "FirstName",
      "type": "text",
      "placeholder": "Enter First Name",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "value": (_vm.fname)
    },
    on: {
      "keypress": function($event) {
        _vm.AvoidSpaceSPOCInfo($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('spocdetailsform.FirstName')),
      expression: "errors.has('spocdetailsform.FirstName')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The First Name field is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Last Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-male'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lname),
      expression: "lname"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "id": "LastName",
      "tabindex": "8",
      "name": "LastName",
      "type": "text",
      "placeholder": "Enter Last Name",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "value": (_vm.lname)
    },
    on: {
      "keypress": function($event) {
        _vm.AvoidSpaceSPOCInfo($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('spocdetailsform.LastName')),
      expression: "errors.has('spocdetailsform.LastName')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Last Name field is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Designation")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-male'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.designation),
      expression: "designation"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "tabindex": "9",
      "id": "Designation",
      "name": "Designation",
      "type": "text",
      "placeholder": "Enter Designation",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "value": (_vm.designation)
    },
    on: {
      "keypress": function($event) {
        _vm.AvoidSpaceSPOCInfo($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.designation = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Email ID")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-envelope'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "id": "email",
      "name": "Email",
      "type": "text",
      "placeholder": "Enter Email",
      "tabindex": "10",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('spocdetailsform.Email')),
      expression: "errors.has('spocdetailsform.Email')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('spocdetailsform.Email')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Mobile Number")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-phone'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobileno),
      expression: "mobileno"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "tabindex": "11",
      "id": "Mobile Number",
      "name": "Mobile Number",
      "type": "text",
      "placeholder": "Enter Mobile Number",
      "maxlength": "10",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "value": (_vm.mobileno)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnlty($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobileno = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('spocdetailsform.Mobile Number')),
      expression: "errors.has('spocdetailsform.Mobile Number')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('spocdetailsform.Mobile Number')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Phone Number")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-phone'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneno),
      expression: "phoneno"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "tabindex": "13",
      "id": "phone",
      "name": "Phone Number",
      "type": "text",
      "placeholder": "Enter Phone Number",
      "maxlength": "12",
      "minlength": "6",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "value": (_vm.phoneno)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnlty($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneno = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('spocdetailsform.Phone Number')),
      expression: "errors.has('spocdetailsform.Phone Number')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('spocdetailsform.Phone Number')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Extension (If Any)")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.extension),
      expression: "extension"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Extension')
    },
    attrs: {
      "tabindex": "14",
      "id": "extension",
      "name": "Extension",
      "type": "text",
      "maxlength": "5",
      "placeholder": "Enter Extension",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "value": (_vm.extension)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.handleTab1(2)
      },
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.extension = $event.target.value
      }
    }
  })])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[3]),
      expression: "accordianTab[3]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "checkboxBD",
      "id": "chck3"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[3]) ? _vm._i(_vm.accordianTab[3], null) > -1 : (_vm.accordianTab[3])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(3)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[3],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[3] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[3] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 3, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck3"
    }
  }, [_vm._v("XB SPOC Details")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "bddetailsform"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5",
    attrs: {
      "tabindex": "15"
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.handleTab2(3)
      }
    }
  }, [_c('label', [_vm._v("BD Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    class: {
      changeColor: _vm.disableAllFileds == true
    },
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('treeselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "multiple": true,
      "max-height": 200,
      "clearable": false,
      "options": _vm.bdList,
      "name": "bdname",
      "id": "bdname",
      "placeholder": "Select BD Name",
      "append-to-body": true,
      "valueFormat": "object",
      "disabled": _vm.disableAllFileds
    },
    model: {
      value: (_vm.bdids),
      callback: function($$v) {
        _vm.bdids = $$v
      },
      expression: "bdids"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('bddetailsform.bdname')),
      expression: "errors.has('bddetailsform.bdname')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The BD Name field is required")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.bdLoading))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5",
    attrs: {
      "tabindex": "15"
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.handleTab2(3)
      }
    }
  }, [_c('label', [_vm._v("KAM Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    class: {
      changeColor: _vm.disableAllFileds == true
    },
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('treeselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "multiple": true,
      "max-height": 200,
      "clearable": false,
      "options": _vm.kamList,
      "name": "kamname",
      "id": "kamname",
      "placeholder": "Select KAM Name",
      "append-to-body": true,
      "valueFormat": "object",
      "disabled": _vm.disableAllFileds
    },
    model: {
      value: (_vm.kamids),
      callback: function($$v) {
        _vm.kamids = $$v
      },
      expression: "kamids"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('bddetailsform.kamname')),
      expression: "errors.has('bddetailsform.kamname')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The KAM Name field is required")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.kamLoading))])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[4]),
      expression: "accordianTab[4]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "ClientKYC",
      "id": "chck4"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[4]) ? _vm._i(_vm.accordianTab[4], null) > -1 : (_vm.accordianTab[4])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(4)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[4],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[4] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[4] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 4, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck4"
    }
  }, [_vm._v("Legal Information")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.legelDocumentFlag
    },
    on: {
      "update:active": function($event) {
        _vm.legelDocumentFlag = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    attrs: {
      "data-vv-scope": "legalinformationform"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "box",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companynamecheck),
      expression: "companynamecheck"
    }],
    attrs: {
      "type": "checkbox",
      "tabindex": "16",
      "id": "companynamecheck",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "checked": Array.isArray(_vm.companynamecheck) ? _vm._i(_vm.companynamecheck, null) > -1 : (_vm.companynamecheck)
    },
    on: {
      "change": _vm.fillCompanyName,
      "__c": function($event) {
        var $$a = _vm.companynamecheck,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.companynamecheck = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.companynamecheck = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.companynamecheck = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(1)]), _c('label', [_vm._v("Tick if same as Company Business/Trade Name")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v("Company Registered Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyregistername),
      expression: "companyregistername"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "tabindex": "17",
      "id": "CompanyRegisteredName",
      "name": "CompanyRegisteredName",
      "type": "text",
      "placeholder": "Enter Company Name",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "value": (_vm.companyregistername)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyregistername = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('legalinformationform.CompanyRegisteredName')),
      expression: "errors.has('legalinformationform.CompanyRegisteredName')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Company Registered Name field is required")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyaddresscheck),
      expression: "companyaddresscheck"
    }],
    attrs: {
      "tabindex": "18",
      "type": "checkbox",
      "id": "companyaddresscheck",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "checked": Array.isArray(_vm.companyaddresscheck) ? _vm._i(_vm.companyaddresscheck, null) > -1 : (_vm.companyaddresscheck)
    },
    on: {
      "change": _vm.fillCompanyAddress,
      "__c": function($event) {
        var $$a = _vm.companyaddresscheck,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.companyaddresscheck = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.companyaddresscheck = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.companyaddresscheck = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(2)]), _c('label', {
    attrs: {
      "for": "Commercial"
    }
  }, [_vm._v("Tick if same as Company Business Address")])]), _vm._v(" "), _c('legend', [_vm._v(" Registered Address")]), _vm._v(" "), _c('div', {
    staticClass: "box",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('div', {
    staticClass: " form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Address Line 1")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.raddress1),
      expression: "raddress1"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    attrs: {
      "tabindex": "19",
      "id": "AddressLine1",
      "name": "AddressLine1",
      "placeholder": "Address Line 1",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "value": (_vm.raddress1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.raddress1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('legalinformationform.AddressLine1')),
      expression: "errors.has('legalinformationform.AddressLine1')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Address Line 1 field is required")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Address Line 2")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.raddress2),
      expression: "raddress2"
    }],
    staticClass: "form-control",
    attrs: {
      "tabindex": "20",
      "placeholder": "Address Line 2",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "value": (_vm.raddress2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.raddress2 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("State")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    class: {
      changeColor: _vm.disableAllFileds == true
    },
    attrs: {
      "left": "<i class='fa fa-map-pin'></i>"
    }
  }, [_c('treeselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    attrs: {
      "tabindex": "21",
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.statelist,
      "name": "LegalState",
      "id": "LegalState",
      "placeholder": "Select State",
      "append-to-body": true,
      "disabled": _vm.disableAllFileds
    },
    on: {
      "select": _vm.selectRState
    },
    model: {
      value: (_vm.rstate),
      callback: function($$v) {
        _vm.rstate = $$v
      },
      expression: "rstate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('legalinformationform.LegalState')),
      expression: "errors.has('legalinformationform.LegalState')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The State field is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("City")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    class: {
      changeColor: _vm.disableAllFileds == true
    },
    attrs: {
      "left": "<i class=\"fa fa-map-pin\"></i>"
    }
  }, [_c('treeselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    attrs: {
      "tabindex": "22",
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.rcitylist,
      "name": "LegalCity",
      "id": "LegalCity",
      "placeholder": "Select City",
      "append-to-body": true,
      "disabled": _vm.disableAllFileds
    },
    on: {
      "select": _vm.selectRCity
    },
    model: {
      value: (_vm.rcity),
      callback: function($$v) {
        _vm.rcity = $$v
      },
      expression: "rcity"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('legalinformationform.LegalCity')),
      expression: "errors.has('legalinformationform.LegalCity')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The City field is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Pincode")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class=\"fa fa-map-pin\"></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rpincode),
      expression: "rpincode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('rpincode')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Pincode",
      "name": "Registered Pincode",
      "id": "Registered Pincode",
      "tabindex": "23",
      "maxlength": 6,
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "value": (_vm.rpincode)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnlty($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rpincode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('legalinformationform.Registered Pincode')),
      expression: "errors.has('legalinformationform.Registered Pincode')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('legalinformationform.Registered Pincode')))])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('legend', [_vm._v(" Legal Documents")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('label', [_vm._v("Registration Number")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-id-card-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.regno),
      expression: "regno"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Registration Number')
    },
    attrs: {
      "tabindex": "24",
      "id": "RegistrationNumber",
      "name": "RegistrationNumber",
      "type": "text",
      "placeholder": "Registration Number",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "value": (_vm.regno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.regno = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('legalinformationform.RegistrationNumber')),
      expression: "errors.has('legalinformationform.RegistrationNumber')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Registration Number field is required")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('legalinformationform.registrationdocument')),
      expression: "errors.has('legalinformationform.registrationdocument')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please Upload Registration Number Document")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "file-upload"
  }, [_c('label', {
    staticStyle: {
      "padding": "35px 0px 0px 0px"
    },
    attrs: {
      "for": "registrationdocument"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "title": "Upload Document",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), (_vm.rNoFileName == 'png' || _vm.rNoFileName == 'jpg' || _vm.rNoFileName == 'jpeg') ? _c('i', {
    staticClass: "fa fa-file-image-o",
    attrs: {
      "aria-hidden": "true",
      "title": "Download Document"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.regnoFilePath.filePath)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.rNoFileName == 'pdf') ? _c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.regnoFilePath.filePath)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.rNoFileName == 'doc' || _vm.rNoFileName == 'docx') ? _c('i', {
    staticClass: "fa fa-file-word-o",
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.regnoFilePath.filePath)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    ref: "files",
    attrs: {
      "tabindex": "25",
      "id": "registrationdocument",
      "name": "registrationdocument",
      "accept": ".jpeg,.jpg,.png,.pdf,.doc,.docx",
      "multiple": "multiple",
      "type": "file",
      "disabled": _vm.disableAllFileds == true
    },
    on: {
      "change": _vm.onFileChangedForRegistration
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('label', [_vm._v("PAN")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-id-card-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.panno),
      expression: "panno"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}/
      }),
      expression: "{required: true,  regex:/^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}/}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "id": "PANNumber",
      "name": "PANNumber",
      "type": "text",
      "placeholder": "PAN",
      "tabindex": "26",
      "maxlength": "10",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "value": (_vm.panno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.panno = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('legalinformationform.PANNumber')),
      expression: "errors.has('legalinformationform.PANNumber')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter valid format of PAN")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('legalinformationform.pandocument')),
      expression: "errors.has('legalinformationform.pandocument')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please Upload PAN Number Document.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "file-upload"
  }, [_c('label', {
    staticStyle: {
      "padding": "35px 0px 0px 0px"
    },
    attrs: {
      "for": "pandocument"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "title": "Upload Document",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), (_vm.panFileName == 'png' || _vm.panFileName == 'jpg' || _vm.panFileName == 'jpeg') ? _c('i', {
    staticClass: "fa fa-file-image-o",
    attrs: {
      "aria-hidden": "true",
      "title": "Download Document"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.pannoFilePath.filePath)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.panFileName == 'pdf') ? _c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.pannoFilePath.filePath)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.panFileName == 'doc' || _vm.panFileName == 'docx') ? _c('i', {
    staticClass: "fa fa-file-word-o",
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.pannoFilePath.filePath)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.pannoFilePath.filePath == '' ? 'required' : ''))),
      expression: "`${pannoFilePath.filePath == '' ? 'required' : ''}`"
    }],
    ref: "files",
    attrs: {
      "tabindex": "27",
      "id": "pandocument",
      "name": "pandocument",
      "type": "file",
      "accept": ".jpeg,.jpg,.png,.pdf,.doc,.docx",
      "multiple": "multiple",
      "disabled": _vm.disableAllFileds == true
    },
    on: {
      "change": _vm.onFileChangedForPAN
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('label', [_vm._v("TAN")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-id-card-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tan),
      expression: "tan"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        regex: /^[a-zA-Z]{4}[0-9]{5}[a-zA-Z]{1}/
      }),
      expression: "{ regex:/^[a-zA-Z]{4}[0-9]{5}[a-zA-Z]{1}/}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "id": "TANNumber",
      "name": "TANNumber",
      "type": "text",
      "placeholder": "TAN",
      "maxlength": "10",
      "tabindex": "28",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "value": (_vm.tan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tan = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('legalinformationform.TANNumber')),
      expression: "errors.has('legalinformationform.TANNumber')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter valid format of TAN")])], 1)])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)])]), _vm._v(" "), _c('legend', [_vm._v(" GST Details")]), _vm._v(" "), _c('div', {
    staticClass: "box",
    staticStyle: {
      "overflow": "auto",
      "max-height": "200px"
    }
  }, [_c('div', {
    staticClass: " form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.GSTData), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('b-input-group', [_c('treeselect', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "tabindex": "29",
        "multiple": false,
        "max-height": 200,
        "clearable": false,
        "options": _vm.statelist,
        "placeholder": "Select State",
        "name": _vm.setname(index, 'gststate'),
        "id": _vm.setname(index, 'gststate'),
        "append-to-body": true
      },
      model: {
        value: (data.gststate),
        callback: function($$v) {
          data.gststate = $$v
        },
        expression: "data.gststate"
      }
    })], 1), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('legalinformationform.gststate' + index)),
        expression: "errors.has('legalinformationform.gststate'+index)"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Please select State")])], 1), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (data.gstno),
        expression: "data.gstno"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true,
          regex: /^[0-9]{2}[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}Z[0-9a-zA-Z]{1}$/
        }),
        expression: "{required: true,  regex:/^[0-9]{2}[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}Z[0-9a-zA-Z]{1}$/}"
      }],
      staticClass: "form-control",
      attrs: {
        "tabindex": "30",
        "id": "gstno",
        "name": _vm.setname(index, 'GSTNumber'),
        "id": _vm.setname(index, 'GSTNumber'),
        "type": "text",
        "placeholder": "Enter GST Number",
        "maxlength": "15"
      },
      domProps: {
        "value": (data.gstno)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          data.gstno = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('legalinformationform.GSTNumber' + index)),
        expression: "errors.has('legalinformationform.GSTNumber'+index)"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Please enter valid format of GST Number")])], 1), _vm._v(" "), _c('td', {
      attrs: {
        "tabindex": "31"
      },
      on: {
        "keydown": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
          _vm.handleTab3(4)
        }
      }
    }, [_c('div', {
      staticClass: "file-upload"
    }, [_c('label', {
      attrs: {
        "for": _vm.setname(index, 'gstdocument')
      }
    }, [_c('i', {
      staticClass: "fa fa-upload",
      attrs: {
        "title": "Upload Document",
        "aria-hidden": "true"
      }
    }), _vm._v("  Click to upload GST certificate  \n                                  "), (data.gstdocument.filename == 'png' || data.gstdocument.filename == 'jpg' || data.gstdocument.filename == 'jpeg') ? _c('i', {
      staticClass: "fa fa-file-image-o",
      attrs: {
        "aria-hidden": "true",
        "title": "Download Document"
      },
      on: {
        "click": function($event) {
          _vm.fileview(data.gstdocument.filepath)
        }
      }
    }) : _vm._e(), _vm._v(" "), (data.gstdocument.filename == 'pdf') ? _c('i', {
      staticClass: "fa fa-file-pdf-o",
      attrs: {
        "title": "Download Document",
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.fileview(data.gstdocument.filepath)
        }
      }
    }) : _vm._e(), _vm._v(" "), (data.gstdocument.filename == 'doc' || data.gstdocument.filename == 'docx') ? _c('i', {
      staticClass: "fa fa-file-word-o",
      attrs: {
        "title": "Download Document",
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.fileview(data.gstdocument.filepath)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (("" + (data.gstdocument.filepath == '' ? 'required' : ''))),
        expression: "`${data.gstdocument.filepath == '' ? 'required' : ''}`"
      }],
      attrs: {
        "id": _vm.setname(index, 'gstdocument'),
        "name": _vm.setname(index, 'gstdocument'),
        "type": "file",
        "accept": ".jpeg,.jpg,.png,.pdf,.doc,.docx",
        "multiple": "multiple"
      },
      on: {
        "change": function($event) {
          _vm.uploadGSTDocument($event, index)
        }
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('legalinformationform.gstdocument' + index)),
        expression: "errors.has('legalinformationform.gstdocument'+index)"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Please upload file.")])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [((index + 1) == _vm.GSTData.length) ? _c('i', {
      staticClass: "fa fa-plus-circle fa-2x",
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.addNewGST(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), (index != 0) ? _c('i', {
      staticClass: "fa fa-trash fa-2x",
      staticStyle: {
        "color": "red",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.deleteGST(index)
        }
      }
    }) : _vm._e()])])
  }))])]), _vm._v(" "), _vm._m(8)])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[5]),
      expression: "accordianTab[5]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "ClientKYC",
      "id": "chck5"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[5]) ? _vm._i(_vm.accordianTab[5], null) > -1 : (_vm.accordianTab[5])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(5)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[5],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[5] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[5] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 5, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck5"
    }
  }, [_vm._v("Bank Information")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.cancelCheqFlag
    },
    on: {
      "update:active": function($event) {
        _vm.cancelCheqFlag = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    attrs: {
      "data-vv-scope": "bankinformationform"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Beneficiary Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.beneficaryname),
      expression: "beneficaryname"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "id": "BeneficaryName",
      "name": "BeneficaryName",
      "type": "text",
      "placeholder": "Beneficiary Name",
      "disabled": _vm.disableAllFileds == true,
      "tabindex": "32"
    },
    domProps: {
      "value": (_vm.beneficaryname)
    },
    on: {
      "keypress": function($event) {
        _vm.AvoidSpacebeneficary($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.beneficaryname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('bankinformationform.BeneficaryName')),
      expression: "errors.has('bankinformationform.BeneficaryName')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Beneficiary Name field is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Bank Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankname),
      expression: "bankname"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "id": "BankName",
      "name": "BankName",
      "type": "text",
      "placeholder": "Bank Name",
      "tabindex": "33",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "value": (_vm.bankname)
    },
    on: {
      "keypress": function($event) {
        _vm.AvoidSpacebankname($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bankname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('bankinformationform.BankName')),
      expression: "errors.has('bankinformationform.BankName')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Bank Name field is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Bank Branch")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankbranch),
      expression: "bankbranch"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "id": "BankBranch",
      "name": "BankBranch",
      "type": "text",
      "placeholder": "Bank Branch",
      "tabindex": "34",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "value": (_vm.bankbranch)
    },
    on: {
      "keypress": function($event) {
        _vm.AvoidSpacebankbranch($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bankbranch = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('bankinformationform.BankBranch')),
      expression: "errors.has('bankinformationform.BankBranch')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Bank Branch field is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("IFSC/RTGS")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cube'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ifsc),
      expression: "ifsc"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "id": "IFSCRTGS",
      "name": "IFSCRTGS",
      "type": "text",
      "placeholder": "IFSC/RTGS",
      "tabindex": "35",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "value": (_vm.ifsc)
    },
    on: {
      "keypress": function($event) {
        _vm.AvoidSpace($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ifsc = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('bankinformationform.IFSCRTGS')),
      expression: "errors.has('bankinformationform.IFSCRTGS')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The IFSC/RTGS field is required")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Bank Account Number")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankaccountno),
      expression: "bankaccountno"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Bank Account Number')
    },
    attrs: {
      "id": "BankAccountNumber",
      "name": "BankAccountNumber",
      "type": "text",
      "placeholder": "Bank Account Number",
      "minlength": "9",
      "maxlength": "17",
      "tabindex": "36",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "value": (_vm.bankaccountno)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bankaccountno = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('bankinformationform.BankAccountNumber')),
      expression: "errors.has('bankinformationform.BankAccountNumber')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Bank Account Number field is required")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('bankinformationform.CancelledCheck')),
      expression: "errors.has('bankinformationform.CancelledCheck')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please upload cancelled check")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    attrs: {
      "tabindex": "37"
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.handleTab4(5)
      }
    }
  }, [_c('div', {
    staticClass: "file-upload"
  }, [_c('label', {
    staticStyle: {
      "padding": "30px 0px 0px 0px"
    },
    attrs: {
      "for": "CancelledCheck"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "title": "Upload Document",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), (_vm.cancelCheqFileName == '') ? _c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v(" Click To Upload Cancelled Cheque")]) : _vm._e(), _vm._v(" "), (_vm.cancelCheqFileName == 'png' || _vm.cancelCheqFileName == 'jpg' || _vm.cancelCheqFileName == 'jpeg') ? _c('i', {
    staticClass: "fa fa-file-image-o",
    attrs: {
      "aria-hidden": "true",
      "title": "Download Document"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.bankCancelChequePath.filePath)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.cancelCheqFileName == 'pdf') ? _c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.bankCancelChequePath.filePath)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.cancelCheqFileName == 'doc' || _vm.cancelCheqFileName == 'docx') ? _c('i', {
    staticClass: "fa fa-file-word-o",
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.bankCancelChequePath.filePath)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    ref: "files",
    attrs: {
      "id": "CancelledCheck",
      "name": "CancelledCheck",
      "type": "file",
      "disabled": _vm.disableAllFileds == true
    },
    on: {
      "change": _vm.uploadCancelChecque
    }
  })]), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10)])])])], 1)])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.clientData && _vm.clientData.ClientSystemID != ''),
      expression: "clientData && clientData.ClientSystemID!= ''"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "-btn btn-warning",
    staticStyle: {
      "color": "white",
      "background-color": "#ff9800"
    },
    attrs: {
      "type": "button",
      "tabindex": "38",
      "disabled": _vm.approvesend == true
    },
    on: {
      "click": _vm.sendForApprove
    }
  }, [_vm._v(_vm._s(_vm.approvesend == true ? 'Approved' : 'Send For Approval') + "  "), _c('i', {
    staticClass: "fa",
    class: [_vm.approvesend == true ? 'fa-check' : 'fa-paper-plane']
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button",
      "tabindex": "39",
      "disabled": _vm.disableAllFileds == true
    },
    on: {
      "click": _vm.saveClientKYCDetails
    }
  }, [_vm._v("Save "), _c('i', {
    staticClass: "fa fa-save"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "-btn btn-primary",
    attrs: {
      "type": "button",
      "tabindex": "40",
      "disabled": _vm.disableAllFileds == true
    },
    on: {
      "click": function($event) {
        _vm.saveAndNext('saveandnext')
      }
    }
  }, [_vm._v("Save And Next "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])])])])], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "websiteHelp"
    }
  }, [_vm._v("Client panel user ID will be created based on domain name. "), _c('br'), _vm._v("Example: http://sample.com or http://www.sample.com")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clientnote notemargin"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v("  Note: Allowed PAN Format ZZZZZ1111Z.")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clientnote notemargin"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Note: Allowed TAN Format ZZZZ00000Z.")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clientnote marginattop"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Note: Allowed File Format JPG,JPEG,PDF,PNG,DOC,DOCX.")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clientnote"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Note: File Size Allowed Up to 20MB.")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("GST")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Document")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "clientnote notemargin text-nowrap"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Note: Allowed GST Format 00XXXXX0000X1ZZ.")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clientnote "
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Note: Allowed File Format JPG,JPEG,PDF,PNG,DOC,DOCX.")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clientnote "
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Note: File Size Allowed Up to 20MB.")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa90ff86","hasScoped":true}!./src/modules/clientmanagement/views/client/addclient/clientKYC/clientKYC.component.html
// module id = 592
// module chunks = 3